import React from "react";
import { COLOR_PRIMARY } from "../../constants/colors";

const IconUsers = ({ color = {COLOR_PRIMARY} }) => {
  return (
    <svg
      id="UI_icon_group_light"
      data-name="UI icon/group/light"
      xmlns="http://www.w3.org/2000/svg"
      width="31.111"
      height="28"
      viewBox="0 0 31.111 28"
    >
      <path
        id="Subtract"
        d="M0,12.348A6.223,6.223,0,0,0,5.445,6.174,6.223,6.223,0,0,0,0,0,9.3,9.3,0,0,1,2.334,6.174,9.3,9.3,0,0,1,0,12.348Z"
        transform="translate(19.444 0.048)"
        fill={color}
      />
      <path
        id="Subtract-2"
        data-name="Subtract"
        d="M4.2,10.875a1.556,1.556,0,1,0,3.111,0V7.764A7.778,7.778,0,0,0,0,0,12.456,12.456,0,0,1,3.584,5.449,4.645,4.645,0,0,1,4.2,7.764Z"
        transform="translate(23.803 15.569)"
        fill={color}
      />
      <path
        id="Vector_631_Stroke_"
        data-name="Vector 631 (Stroke)"
        d="M7.778,3.111A4.667,4.667,0,0,0,3.111,7.778v3.111a1.556,1.556,0,1,1-3.111,0V7.778A7.778,7.778,0,0,1,7.778,0h9.333a7.778,7.778,0,0,1,7.778,7.778v3.111a1.556,1.556,0,1,1-3.111,0V7.778a4.667,4.667,0,0,0-4.667-4.667Z"
        transform="translate(0 15.556)"
        fill={color}
      />
      <path
        id="Ellipse_132_Stroke_"
        data-name="Ellipse 132 (Stroke)"
        d="M6.222,12.445a6.222,6.222,0,1,1,6.223-6.223A6.229,6.229,0,0,1,6.222,12.445Zm0-9.334A3.112,3.112,0,1,0,9.334,6.222,3.114,3.114,0,0,0,6.222,3.111Z"
        transform="translate(6.222)"
        fill={color}
      />
    </svg>
  );
};

export default IconUsers;
